export * from './is-relative-url';
export * from './is-same-origin';
